import styled from 'styled-components';

export const SectionBoxContainer = styled.div`
    // text-shadow: black 0px 0px 5px;
    // background-color: black;
    width: 100%;
    height: auto;
    margin-bottom: min(35px, 10%);
`;